const AUTO_LOCK_KEY = 'tresor_auto_lock_minutes';
const LOCK_POLICY_KEY = 'tresor_lock_upload_policy';
const TAB_LOCK_KEY = 'tresor_lock_on_tab_hidden';

export const AUTO_LOCK_OPTIONS = [
  { value: 0, label: 'Aus' },
  { value: 5, label: '5 Minuten' },
  { value: 15, label: '15 Minuten' },
  { value: 30, label: '30 Minuten' },
  { value: 60, label: '60 Minuten' },
];

export const LOCK_UPLOAD_POLICIES = [
  { value: 'finish_current', label: 'Laufende Uploads beenden' },
  { value: 'strict', label: 'Sofort stoppen (streng)' },
];

export function readAutoLockMinutes() {
  try {
    const raw = localStorage.getItem(AUTO_LOCK_KEY);
    if (raw == null) return 15;
    const n = parseInt(raw, 10);
    return AUTO_LOCK_OPTIONS.some((o) => o.value === n) ? n : 15;
  } catch (_) {
    return 15;
  }
}

export function writeAutoLockMinutes(minutes) {
  localStorage.setItem(AUTO_LOCK_KEY, String(minutes));
}

export function readLockUploadPolicy() {
  try {
    const raw = localStorage.getItem(LOCK_POLICY_KEY);
    return raw === 'strict' ? 'strict' : 'finish_current';
  } catch (_) {
    return 'finish_current';
  }
}

export function writeLockUploadPolicy(policy) {
  localStorage.setItem(LOCK_POLICY_KEY, policy === 'strict' ? 'strict' : 'finish_current');
}

export function readLockOnTabHidden() {
  try {
    return localStorage.getItem(TAB_LOCK_KEY) === '1';
  } catch (_) {
    return false;
  }
}

export function writeLockOnTabHidden(enabled) {
  localStorage.setItem(TAB_LOCK_KEY, enabled ? '1' : '0');
}
